/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './icd-10-procedure.reducer';

export const ICD10ProcedureDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const iCD10ProcedureEntity = useAppSelector(state => state.iCD10Procedure.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="iCD10ProcedureDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.iCD10Procedure.detail.title">ICD10Procedure</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.iCD10Procedure.id">Id</Translate>
            </span>
          </dt>
          <dd>{iCD10ProcedureEntity.id}</dd>
          <dt>
            <span id="pcsId">
              <Translate contentKey="tinyMedicRestApp.iCD10Procedure.pcsId">Pcs Id</Translate>
            </span>
          </dt>
          <dd>{iCD10ProcedureEntity.pcsId}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.iCD10Procedure.code">Code</Translate>
            </span>
          </dt>
          <dd>{iCD10ProcedureEntity.code}</dd>
          <dt>
            <span id="validForCoding">
              <Translate contentKey="tinyMedicRestApp.iCD10Procedure.validForCoding">Valid For Coding</Translate>
            </span>
          </dt>
          <dd>{iCD10ProcedureEntity.validForCoding ? 'true' : 'false'}</dd>
          <dt>
            <span id="shortDesc">
              <Translate contentKey="tinyMedicRestApp.iCD10Procedure.shortDesc">Short Desc</Translate>
            </span>
          </dt>
          <dd>{iCD10ProcedureEntity.shortDesc}</dd>
          <dt>
            <span id="longDesc">
              <Translate contentKey="tinyMedicRestApp.iCD10Procedure.longDesc">Long Desc</Translate>
            </span>
          </dt>
          <dd>{iCD10ProcedureEntity.longDesc}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.iCD10Procedure.active">Active</Translate>
            </span>
          </dt>
          <dd>{iCD10ProcedureEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="revision">
              <Translate contentKey="tinyMedicRestApp.iCD10Procedure.revision">Revision</Translate>
            </span>
          </dt>
          <dd>{iCD10ProcedureEntity.revision}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.iCD10Procedure.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{iCD10ProcedureEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.iCD10Procedure.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{iCD10ProcedureEntity.lastupdated}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.iCD10Procedure.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{iCD10ProcedureEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.iCD10Procedure.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{iCD10ProcedureEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/icd-10-procedure" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/icd-10-procedure/${iCD10ProcedureEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ICD10ProcedureDetail;
